<template>{{title_view}}</template>

<script>
import { CONST_ADMIN_PATH} from "../constants/consts";
import {useRoute} from "vue-router";
import {LS} from "../services/translate";

export default {
    setup(){
        const route = useRoute();
            let title_view = LS("База знаний");

            if(route.path === CONST_ADMIN_PATH) {
                title_view = LS("Редактор базы знаний");
            }

            //console.log('title_view',title_view)

        return {
            title_view
        }
    },
}
</script>

<style scoped>

</style>